"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationSummary = void 0;
var _mui = require("@ori-ui/mui");
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const RootDiv = (0, _mui.styled)('div')(({
  theme
}) => ({
  '&:not(:empty)': {
    marginBottom: theme.spacing(3)
  }
}));
const ValidationSummary = props => {
  const status = props.validationStatus;
  if (!status) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {});
  }
  const getErrorMessage = error => {
    const validationMessage = error;

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions -- is not always truthy
    if (validationMessage.localization) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: validationMessage.localization.id,
        values: validationMessage.params
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: error,
      defaultMessage: error
    });
  };
  const renderError = (error, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
    error: true,
    children: getErrorMessage(error)
  }, index);
  const errors = status.modelErrors.map((error, index) => renderError(error, index));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RootDiv, {
    children: errors
  });
};
exports.ValidationSummary = ValidationSummary;
